<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Novo Registro</div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label><span class="required">*</span> Colaborador</label>
            <select v-model="vacation.user_id" class="form-control">
              <option v-for="user in users" :key="user.id" :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Início das Férias</label>
            <date-time
              v-model="vacation.start_date"
              format="YYYY-MM-DD"
              formatted="DD/MM/YYYY"
              output-format="YYYY-MM-DD"
              :onlyDate="true"
              :no-button-now="true"
            >
              <input
                type="text"
                class="form-control"
                :value="vacation.start_date"
              />
            </date-time>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Fim das Férias</label>
            <date-time
              v-model="vacation.end_date"
              format="YYYY-MM-DD"
              formatted="DD/MM/YYYY"
              output-format="YYYY-MM-DD"
              :onlyDate="true"
              :no-button-now="true"
            >
              <input
                type="text"
                class="form-control"
                :value="vacation.end_date"
              />
            </date-time>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Número de Dias</label>
            <input
              type="text"
              class="form-control"
              v-model="vacation.number_of_days"
            />
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Abono Pecuniário</label>
            <select v-model="vacation.pecuniary_allowance" class="form-control">
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>
        </div>
        <div class="block text-right">
          <router-link to="/departments" class="btn btn-info">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-success" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      vacation: {
        title: "",
        description: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;

      const api = this.$store.state.api + "vacations";

      self.$http
        .post(api, self.vacation)
        .then((response) => {
          self.$message("Sucesso", `Férias agendadas com sucesso`, "success");
          this.$router.push("/vacations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit: function () {
      const self = this;
      const api = self.$store.state.api + "departments/" + self.vacation.id;

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Departamento editado com sucesso`,
            "success"
          );
          this.$router.push("/departments");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function (id) {
      let self = this;
      let api = self.$store.state.api + "users/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUsers();

    let id = self.$route.params.id;
    if (id) {
      self.getDepartment(id);
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Vacations/Entity.vue